import { Bridge, type ParentEvDataVoicePermission, platform } from '@/common/bridge';
import * as env from '@/common/environment';
import { analytics, VOICE_EVENTS } from '@/common/logs';

export const getShouldUseNativeMicroAccessCheck = (): boolean =>
  platform === 'app' && Boolean(env.get('app')?.nativeMicroAccessCheck);

/**
 * Asks the native host whether microphone access is available (Android app WebView flow).
 */
export const requestNativeAppVoiceMicrophonePermission = (): Promise<boolean> =>
  new Promise<boolean>((resolve) => {
    const removeListener = Bridge.listenFromParent<ParentEvDataVoicePermission>('APP_HAS_VOICE_PERMISSION', (data) => {
      analytics.trackVoiceEvent({
        name: VOICE_EVENTS.VOICE_MICROPHONE_PERMISSION,
        metadata: { permission: data.permission },
      });
      removeListener();
      resolve(Boolean(data.permission));
    });

    analytics.trackVoiceEvent({ name: VOICE_EVENTS.VOICE_MICROPHONE_PERMISSION_REQUESTED });
    Bridge.sendToParent('APP_HAS_VOICE_PERMISSION');
  });

/** Notifies the native host to check microphone access; does not block the UI on the response. */
export const notifyNativeAppVoiceMicrophonePermission = (): void => {
  void requestNativeAppVoiceMicrophonePermission();
};

/** Opens app settings so the user can grant microphone access (same as legacy permission dialog primary action). */
export const sendNativeAppVoiceMicrophoneSettings = (): void => {
  analytics.trackVoiceEvent({ name: VOICE_EVENTS.VOICE_MICROPHONE_PERMISSION_OPEN_SETTINGS });
  Bridge.sendToParent('APP_GO_SETTING');
};
